const functionsBaseUrl =
  process.env.REACT_APP_ENQUIRY_SUPABASE_URL ||
  process.env.REACT_APP_SUPABASE_URL;

const functionUrl = functionsBaseUrl
  ? `${functionsBaseUrl}/functions/v1/rls-bypass-query`
  : "";

export async function rlsBypassQuery(requestBody) {
  if (!functionUrl) {
    throw new Error(
      "Missing function base URL. Set REACT_APP_ENQUIRY_SUPABASE_URL or REACT_APP_SUPABASE_URL."
    );
  }

  const response = await fetch(functionUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestBody),
  });

  const result = await response.json().catch(() => ({}));

  if (!response.ok || result.error) {
    throw new Error(result.error || `Request failed with status ${response.status}`);
  }

  return result.data ?? [];
}
